import { render, staticRenderFns } from "./ViewOrderSummary.vue?vue&type=template&id=5dc271bc"
import script from "./ViewOrderSummary.vue?vue&type=script&lang=js"
export * from "./ViewOrderSummary.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ViewOrderSummary.vue?vue&type=style&index=1&id=5dc271bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports